import React, { Component } from 'react';
import '../myutils';
import { AppBarMobile, withDataProvider, translate } from 'react-admin';
import Chart from 'react-apexcharts'
import { Redirect } from 'react-router';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import TotalUnits from './TotalUnits';
import { configAPI } from '../config'
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import moment from 'moment'; //'../res/jssip';
import AttachMoney from '@material-ui/icons/AttachMoney';
import MoneyOff from '@material-ui/icons/MoneyOff';
import DateRange from '@material-ui/icons/DateRange';
import ArrowForward from '@material-ui/icons/ArrowForward';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import ShowTransactions from './ShowTransactions';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { DialogContent, TextField } from '@material-ui/core';

const styles = {
    welcome: { marginBottom: '2em' },
    flex: { display: 'flex' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em', maxWidth: '50%', padding: '0em 1em' },
    singleCol: { marginTop: '1em' },
    cardStyle0: {
        width: '100%',
        display: 'inline-block',
        verticalAlign: 'top'
    },
    cardStyle1: {
        width: '50%',
        display: 'inline-box',
        verticalAlign: 'top',
        padding: ''
    }
};

class Statistics extends Component {
    state = {};
    componentDidMount() {
        const ReqGetSession = new Request(configAPI.api.prod + 'GetSession?token=' + sessionStorage.B.encodeDecode());
        fetch(ReqGetSession)
            .then(response => response.json())
            .then(session => {
                if (session.responseStatus === 'OK') {
                    this.setState({ units: Number((session.units).toFixed(1)) });
                    this.setState({ userID: session.username });
                    this.setState({ unitsExpireDate: session.unitsExpireDate });
                    sessionStorage.setItem('userDID', session.username)
                } else return (<Redirect to="/route/to/redirect" />);
                const ReqGetTransactions = new Request(configAPI.api.prod + 'GetTransactions?token=' + sessionStorage.B.encodeDecode());
                return fetch(ReqGetTransactions)
                    .then(response => { return response.json(); })
                    .then(trans => {
                        if (trans.responseStatus === 'OK') {
                            let transactions = trans.transactions;
                            this.setState({ transactions: transactions })
                            let myseries = [0, 0, 0, 0, 0];
                            let totalAmount = 0;
                            let totalUseThisMonth = 0;
                            let totalPurchaseThisMonth = 0;
                            var thisMonth = moment().format('YYYY-MM');
                            transactions.forEach(trn => {
                                if (trn.description.includes("SMS")) myseries[0] -= parseInt(trn.amount);
                                else if (trn.description.includes("Start-")) myseries[1] -= parseInt(trn.amount);
                                else if (trn.description.includes("transfer to")) myseries[2] -= parseInt(trn.amount);
                                else if (trn.description.includes("Units expired")) myseries[3] -= parseInt(trn.amount);
                                else if (trn.amount < 0) myseries[4] -= parseInt(trn.amount);
                                if (trn.transactionTime.includes(thisMonth)) {
                                    if (trn.amount < 0) {
                                        totalUseThisMonth -= parseInt(trn.amount);
                                    }
                                    else {
                                        totalPurchaseThisMonth += parseInt(trn.amount);
                                    }
                                }

                                if (parseInt(trn.amount) < 0) totalAmount -= parseInt(trn.amount);
                            });
                            for (var i = 0; i < 5; i++) myseries[i] = totalAmount / 100 * myseries[i];
                            this.setState({ series: myseries });
                            this.setState({ totalUseThisMonth: totalUseThisMonth });
                            this.setState({ totalPurchaseThisMonth: totalPurchaseThisMonth });
                            this.setState({ lastTransaction: transactions[0].description + '(' + transactions[0].transactionTime + ')' });

                        } else return (<Redirect to="/route/to/redirect" />);
                    })
            })
    }

    constructor(props) {
        super(props);
        const { translate } = this.props;
        var labels = [translate('trans.SMS'), translate('trans.Campaign'), translate('trans.Transfer'), translate('trans.Expired'), translate('trans.Others')];

        this.state = {
            showPasswordError: false,
            showTransferError: false,
            showSuccess: false,
            options: {
                title: {
                    text: translate('trans.useUnitsStat'),
                    align: 'right'
                },
                subtitle: {
                    // text: translate('trans.SMS'),
                    // align: 'right'
                },
                legend: {
                    position: 'bottom'
                },
                labels: labels //['SMS', 'Campaign', 'Transfer', 'Expired']
            },
            series: [{
                name: 'series-1',
                data: []
            }]
        }
    }

    handleClickOpen = () => {
        this.setState({ showTransferDialog: true });
      };
    
    handleClose = () => {
        this.setState({ showTransferDialog: false });
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleSendSubmit = () => {
        const ReqLogin = new Request(configAPI.api.prod + 'Login?username=' + sessionStorage.userDID+'&password='+this.state.password);
        fetch(ReqLogin)
            .then(response => response.json())
            .then(respJSON => {
                if (respJSON.responseStatus === 'OK') {
                    this.setState({showError:false});
                    const ReqTransfer = new Request(configAPI.api.prod + 'TransferUnits?token=' + respJSON.token+'&destination='+this.state.destination+ '&amount='+this.state.amount);
                    fetch(ReqTransfer)
                        .then(response => response.json())
                        .then(respJSON => {
                            if (respJSON.responseStatus === 'OK') {
                                this.setState({showTransferError: false, showSuccess: true})
                            }
                            else this.setState({showTransferError: true, showPasswordError: false})
                        })
                } else this.setState({showPasswordError: true});
            })
    };
    
    render() {
        const {
            transactions,
            units, totalPurchaseThisMonth, totalUseThisMonth, unitsExpireDate, lastTransaction
        } = this.state;
        const { width, classes, translate } = this.props;
        return (
            <div>
                {width === 1 && <AppBarMobile title="Yemot-Admin" />}
                <div className={classes.cardStyle1}>
                    <TotalUnits value={units} />
                </div><hr />
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <Paper>
                            <List>
                                <ListItem>
                                    <Avatar>
                                        <AttachMoney />
                                    </Avatar>
                                    <ListItemText primary={translate('trans.units_purchased')} secondary={totalPurchaseThisMonth} />
                                </ListItem>
                                <ListItem>
                                    <Avatar>
                                        <MoneyOff />
                                    </Avatar>
                                    <ListItemText primary={translate('trans.units_used')} secondary={totalUseThisMonth} />
                                </ListItem>
                                <ListItem>
                                    <Avatar>
                                        <DateRange />
                                    </Avatar>
                                    <ListItemText primary={translate('trans.units_expired_date')} secondary={unitsExpireDate} />
                                </ListItem>
                                <ListItem>
                                    <Avatar>
                                        <ArrowForward />
                                    </Avatar>
                                    <ListItemText primary={translate('trans.units_last_transaction')} secondary={lastTransaction} />
                                </ListItem>
                            </List>
                            <Button color="primary" fullWidth={true} variant="contained" onClick={this.handleClickOpen}>{translate('trans.transfer_units')}</Button>
                        </Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <Paper>
                            {/* <PopUpTable name={'units'} transactions={transactions} /> */}
                            <Chart options={this.state.options} series={this.state.series} type="donut" width={500} height={300} />
                        </Paper>
                    </Grid>
                    <Grid item xs={12}>
                        <ShowTransactions transactions={transactions} />
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.showTransferDialog}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <IconButton color="inherit" onClick={(e) => this.handleClose(e)} aria-label="Close" style={{ float: 'right' }}>
                        <CloseIcon />
                    </IconButton>
                    <DialogContent>
                    <Paper>
                            <TextField
                              id="destination"
                              label={translate('trans.destination')}
                              helperText={translate('trans.destinationHT')}
                              value={this.state.delimiter}
                              onChange={this.handleChange('destination')}
                              margin="normal"
                            />
                            <br/>
                            <TextField
                              id="transferAmount"
                              label={translate('trans.transferAmount')}
                              helperText={translate('trans.transferAmountHT')}
                              type="number"
                              defaultValue={0}
                              value={this.state.untis}
                              onChange={this.handleChange('transferAmount')}
                              margin="normal"
                            />
                            <br/>
                            <TextField
                              id="password"
                              type = "password"
                              label={translate('trans.password')}
                              helperText={translate('trans.passwordHT')}
                              value={this.state.password}
                              onChange={this.handleChange('password')}
                              margin="normal"
                            />
                          </Paper>
                          <h3 style={{ color: 'orange' }}>{translate('trans.transferWarning')}</h3>
                          {(this.state.showPasswordError)&&(<h3 style={{ color: 'red' }}>{translate('trans.passwordFailed')}</h3>)}
                          {(this.state.showTransferError)&&(<h3 style={{ color: 'red' }}>{translate('trans.transferError')}</h3>)}
                          {(this.state.showSuccess)&&(<h3 style={{ color: 'blue' }}>{translate('trans.transferSuccessful')}</h3>)}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={(e) => this.handleSendSubmit(e)} color="primary">
                            {translate('ra.action.ok')}
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    version: state.admin.ui.viewVersion,
});

export default
    compose(
        connect(mapStateToProps),
        withDataProvider, withStyles(styles)
    )(translate(Statistics)); 